import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';
import {
  GET_RAFFLE_CONCLUDED_TICKETS_SUCCESS,
  GET_RAFFLE_PLAYED_TICKETS_SUCCESS,
  GET_RAFFLE_TICKETS_FAILURE,
  GET_RAFFLE_TICKETS_REQUEST,
  RESET_RAFFLE_TICKETS_PAGINATION,
  GET_RAFFLE_TICKET_DETAIL_REQUEST,
  GET_RAFFLE_TICKET_DETAIL_SUCCESS,
  GET_RAFFLE_TICKET_DETAIL_FAILURE
} from 'Store/constants';
import { openModal } from 'Store/actions';

export const getRaffleTickets = ticketStatus => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_RAFFLE_TICKETS_REQUEST,
    });
    let pagination = getState().raffleV2.raffleTickets.pagination;

    const url = '/mobile/digital-lottery/played-coupons';
    const res = await axios.post(url, {
      gameType: 'RAFFLE',
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      status: ticketStatus === 'playedCoupons' ? ['PLAYED'] : ['WON', 'LOST'],
    });


    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1
    };

    dispatch({
      type: ticketStatus === 'playedCoupons' ? GET_RAFFLE_PLAYED_TICKETS_SUCCESS : GET_RAFFLE_CONCLUDED_TICKETS_SUCCESS,
      payload: res.data.body,
      pagination
    });
  } catch (e) {
    if (e.response.status !== 200) {
      dispatch(openModal('raffleErrorModal', { turnBackSantra: true, forceBackOnClose: true }));
    }
    dispatch({
      type: GET_RAFFLE_TICKETS_FAILURE,
      payload: (e.response && e.response.data) || errorMessage,
    });
  }
};

export const getRaffleTicketDetail = drawId => async dispatch => {
  try {
    dispatch({
      type: GET_RAFFLE_TICKET_DETAIL_REQUEST,
    });
    const url = `/mobile/digital-lottery/played-coupons-detail/${drawId}`;
    const res = await axios.get(url);


    dispatch({
      type: GET_RAFFLE_TICKET_DETAIL_SUCCESS,
      payload: res.data
    });
  } catch (e) {
    if (e.response.status !== 200) {
      dispatch(openModal('raffleErrorModal', { turnBackSantra: true, forceBackOnClose: true }));
    }

    dispatch({
      type: GET_RAFFLE_TICKET_DETAIL_FAILURE,
      payload: (e.response && e.response.data) || errorMessage,
    });
  }
};

export const resetTicketsPagination = scrollToTop => async dispatch => {
  if (scrollToTop) {
    document.getElementsByClassName('infinite-scroll-component')[0].scrollTo(0, 0);
  }
  dispatch({
    type: RESET_RAFFLE_TICKETS_PAGINATION
  });
};